import React from "react";
import { Typography, Space } from 'antd';
import { GithubOutlined } from '@ant-design/icons';

const { Text } = Typography;

function Footer() {
	return (
		<Space direction="vertical" size="small">
			<Space size="small">
				<Text>BI</Text>
				<Text type="secondary">© {new Date().getFullYear()}</Text>
			</Space>
		</Space>
	);
}

export default Footer;